/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    $Container,
    $GraphicsBox,
    $Sprite,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {$FullScreenCover} from '@gongxigames/framework/slotV2/JSX/FullScreenCover';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';

const background = LSViewConfig.preloaderBgParams;

export const renderBackground = () => (
    <$Container>
        <$FullScreenCover
            width={1}
            height={1}
            align={[0, 0]}
        >
            <$GraphicsBox
                boxX={0}
                boxY={0}
                boxWidth={1}
                boxHeight={1}

                boxColor={background.color}
                boxAlpha={1}
                renderable={true}
                interactive={false}
                buttonMode={false}
            />
        </$FullScreenCover>
        <$FullScreenCover
            width={background.size.width}
            height={background.size.height}
            align={[0.5, 0.5]}
        >
            <$Sprite texture={background.name} />
        </$FullScreenCover>
    </$Container>
);